import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Form, Input, Image } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { UpdateProfileApi } from "../../../api/request/setting/setting";
import Edit from "../../../assets/Edit";

const UpdateProfileModal = ({ client, setClient, isOpen, setIsOpen }) => {
  const [form] = Form.useForm();
  const fileInputRef = useRef(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const newFile = e.target.files[0];
    if (newFile) {
      const previewUrl = URL.createObjectURL(newFile);
      const newFileObj = {
        uid: Date.now().toString(),
        name: newFile.name,
        originFileObj: newFile,
        url: previewUrl,
      };
      setFileList([newFileObj]);
      form.setFieldsValue({ profile_image: [newFileObj] });
    }
  };

  const handleEditClick = () => {
    fileInputRef?.current?.click();
  };

  const UploadButton = () => (
    <div className="w-[100px] h-[100px] rounded-lg overflow-hidden flex items-center justify-center">
      {fileList?.length > 0 ? (
        <div className="relative h-full w-full">
          <img
            src={fileList[0]?.url || client?.profile_image}
            alt="avatar"
            className="h-full w-full object-cover"
          />
          <div
            className="absolute bottom-1 right-1 bg-primary rounded-full p-2 cursor-pointer"
            onClick={handleEditClick}
          >
            <Edit color="#fff" className="!size-4" />
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="h-full w-full flex flex-col items-center justify-center gap-2 border border-dashed"
          onClick={handleEditClick}
        >
          <img src="/assets/icons/upload.svg" alt="icon" className="size-5" />
          Upload
        </button>
      )}
    </div>
  );

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("user_id", client?.id);
      formData.append("first_name", values?.first_name);
      formData.append("last_name", values?.last_name);
      formData.append("mobile_no", values?.mobile_no);

      if (values?.profile_image?.length) {
        formData.append("profile_img", values?.profile_image[0].originFileObj);
      }
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await UpdateProfileApi(formData, apiHeader);
      if (data?.status) {
        toast.success(data?.message);
        setClient({ ...client, ...data?.data });
        if (data?.data?.profile_image)
          setFileList([
            { uid: "1", url: data?.data?.profile_image, status: "done" },
          ]);
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && client?.profile_image) {
      setFileList([
        {
          uid: "1",
          name: "profile_image",
          status: "done",
          url: client?.profile_image,
        },
      ]);
    }
  }, [isOpen, client]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Update Profile"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        size="large"
        autoComplete="off"
        initialValues={client}
        onFinish={handleSubmit}
      >
        <div>
          <Form.Item name="profile_image">
            <UploadButton />
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleChange}
            />
          </Form.Item>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
              }}
              src={previewImage}
            />
          )}
        </div>

        <div className="grid lg:grid-flow-col gap-4">
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[{ required: true, message: "Please enter first name." }]}
          >
            <Input placeholder="First name" />
          </Form.Item>

          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Please enter last name." }]}
          >
            <Input placeholder="Last name" />
          </Form.Item>
        </div>

        <Form.Item
          name="mobile_no"
          label="Mobile No."
          className="mb-0"
          rules={[
            { required: true, message: "Please enter mobile number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Phone number must be 10 digits",
            },
          ]}
        >
          <Input type="number" placeholder="Mobile No." />
        </Form.Item>

        <div className="text-center mt-5">
          <LoadableButton
            type="submit"
            lable="Submit"
            isLoading={isLoading}
            loadingLable="Updating profile..."
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default UpdateProfileModal;
